export class UserWrapper {
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    emailId: string;
    isActive: boolean;
}